import { Button, Table } from 'antd';
import React, { useState, useEffect } from 'react'
import AccessControl from '../../../components/AccessControl';


export default function CalibrationList({ data, delteFromList, authUser }) {
    const [dataSource, setDataSource] = useState([])
    const [columns, setColumns] = useState([
        {
            title: 'Sl.',
            dataIndex: 'sl',
            key: 'sl',
            render: (_, __, index) => index + 1,
        },
        {
            title: 'Quantity (ltr.)',
            dataIndex: 'quantity',
            key: 'quantity',
        },
        {
            title: 'Voltage/Height',
            dataIndex: 'voltage',
            key: 'voltage',
        },

    ]);

    useEffect(() => {
        const cols = columns.filter(item => item.key !== 'action')
        cols.push({
            title: '',
            dataIndex: 'action',
            key: 'action',
            render: (_, record) => {
                return (
                    <AccessControl
                        resource={'AssetFuelSensorCalibration'}
                        permissionNeeded={'d'}
                        roles={authUser ? authUser.roles : []}
                        render={(props) => (
                            <Button icon='close' type='danger' size='small'
                                onClick={() => {
                                    setDataSource(currentDataSource => {
                                        delItem(record.quantity, record.voltage, currentDataSource)
                                        return currentDataSource
                                    })
                                }}>
                                Delete
                            </Button>
                        )} />
                )
            }

        })
        setColumns(cols)
    }, [authUser])

    const delItem = (quantity, voltage, currentDataSource) => {
        delteFromList(quantity, voltage, currentDataSource)
    }

    useEffect(() => {
        if (data && data.length) {
            data.sort((a, b) => a.quantity - b.quantity)
        }
        setDataSource(data || [])
    }, [data])
    return (
        <div style={{ width: '100%', padding: '0px' }}>
            <Table pagination={false} dataSource={dataSource} columns={columns} size='small' rowKey={'quantity'} scroll={{ y: 300 }} />
        </div>
    )
}
